import { t } from '@lingui/macro'

import { getMajorMinorVersion } from '../../components/app-update-card/update-messages'

import type { Props as SlideProps } from './components/app-update'

// Slides for version 6.0
export const slides_v6_0: SlideProps[] = [
  {
    title: t({
      message: 'Taken kregen een grondige update',
      comment: 'AppUpdate page 1 title',
    }),
    message: t({
      message: "Openstaande en afgewerkte taken kan je vanaf nu terugvinden onder 'Taken'.",
      comment: 'AppUpdate page 1 body',
    }),
    graphic: '/img/svg/app-update-1.svg',
  },
  {
    title: t({
      message: 'Je agenda bevat nu enkel afspraken en opnames',
      comment: 'AppUpdate page 2 title',
    }),
    message: t({
      message: "We houden je agenda overzichtelijker door meer zaken onder 'Taken' te plaatsen.",
      comment: 'AppUpdate page 2 body',
    }),
    graphic: '/img/svg/app-update-2.svg',
  },
  {
    title: t({
      message: 'Jouw communicatie op één plaats',
      comment: 'AppUpdate page 3 title',
    }),
    message: t({
      message: "Ongelezen en gelezen berichten kan je vanaf nu terugvinden onder 'Berichten'.",
      comment: 'AppUpdate page 3 body',
    }),
    graphic: '/img/svg/app-update-3.svg',
  },
]

// Future versions can be added here

/**
 * Get update slides for a specific version
 */
export const getUpdateSlidesForVersion = (version: string): SlideProps[] => {
  const majorMinorVersion = getMajorMinorVersion(version)
  if (majorMinorVersion === '6.0') {
    return slides_v6_0
  }

  return []
}
